import React from "react";
import PropTypes from "prop-types";
import isNumber from "lodash/isNumber";
import { FormattedNumber, defineMessages, FormattedMessage } from "react-intl";

const messages = defineMessages({
  percentOff: "{percent}% off",
});

export const StrikethroughProductPrice = ({
  price,
  currency,
  discountPercent,
}) => {
  return (
    <>
      <s data-testid="strikethrough">
        <FormattedNumber
          value={price}
          // eslint-disable-next-line react/style-prop-object
          style="currency"
          currency={currency}
        />
      </s>

      {isNumber(discountPercent) && discountPercent > 0 && (
        <FormattedMessage
          {...messages.percentOff}
          values={{ percent: discountPercent }}
        >
          {(text) => ` (${text})`}
        </FormattedMessage>
      )}
    </>
  );
};

StrikethroughProductPrice.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  discountPercent: PropTypes.number,
};
